import type { SVGProps } from 'react'

import { ChartValueFormat, formatChartDataLabelValue } from './chartFormat'

type ChartRow = Record<string, unknown>

export interface VerticalBarTotalLabelProps {
  x?: number
  y?: number
  width?: number
  height?: number
  /** Bar row index; Recharts strips `payload` from label props, so we join via rows[index]. */
  index?: number
}

const sumSeriesOnRow = (
  row: ChartRow | undefined,
  seriesDataKeys: readonly string[],
): number => seriesDataKeys.reduce((acc, k) => acc + (Number(row?.[k]) || 0), 0)

/** Total above the stacked column (render on the top segment only). */
interface StackedVerticalTotalLabelProps extends VerticalBarTotalLabelProps {
  seriesDataKeys: readonly string[]
  rows: readonly ChartRow[]
  valueFormat?: ChartValueFormat
  dataLabelFill?: string
}

export const StackedVerticalTotalLabel = ({
  x,
  y,
  width,
  index,
  seriesDataKeys,
  rows,
  valueFormat,
  dataLabelFill = 'white',
}: StackedVerticalTotalLabelProps) => {
  const payload = typeof index === 'number' ? rows[index] : undefined
  if (x == null || y == null || width == null || !payload) return null
  const total = sumSeriesOnRow(payload, seriesDataKeys)
  const textProps = {
    fill: dataLabelFill,
    fontSize: 12,
    fontWeight: 700,
  } satisfies SVGProps<SVGTextElement>

  return (
    <text x={x + width / 2} y={y - 8} textAnchor="middle" {...textProps}>
      {formatChartDataLabelValue(total, valueFormat)}
    </text>
  )
}
